var getEnrollmentAccounts = function (accountSummaries) {
    var _a;
    var tmpEnrolledAccounts = [];
    // If any of the account summary responses include enrollments: ["CREIDIT_HEALTH"], they are enrolled in vantage
    accountSummaries.forEach(function (accountSummary) {
        var _a, _b;
        if (((_a = accountSummary.data) === null || _a === void 0 ? void 0 : _a.accountId) &&
            ((_b = accountSummary.data) === null || _b === void 0 ? void 0 : _b.enrollments.indexOf("CREDIT_HEALTH")) !== -1) {
            tmpEnrolledAccounts.push(accountSummary.data.accountId);
        }
    });
    /*
     * If they have accounts with allowable equal to true, we filter that list of accounts to find one
     * with conditions containing ['OPEN']. The first account fitting this criteria is prefered to be enrolled in CREDIT_HEALTH
     */
    var findTheFirstAccountWithOpenCondition = accountSummaries.find(function (account) { var _a; return ((_a = account.data) === null || _a === void 0 ? void 0 : _a.conditions.indexOf("OPEN")) !== -1; });
    return {
        accountToEnroll: ((_a = findTheFirstAccountWithOpenCondition === null || findTheFirstAccountWithOpenCondition === void 0 ? void 0 : findTheFirstAccountWithOpenCondition.data) === null || _a === void 0 ? void 0 : _a.accountId) || "",
        enrolledAccounts: tmpEnrolledAccounts,
    };
};
export default getEnrollmentAccounts;
